import { SVGProps, Ref, forwardRef } from 'react';

export const CheckboxCheckSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m18 9-8 8-4.5-4.5 1.273-1.273L10 14.454l6.727-6.727z"
            fill="currentColor"
        />
    </svg>
));
CheckboxCheckSize24Glyph.displayName = 'CheckboxCheckSize24Glyph';
